import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {ColumnInstance, Row, useTable} from 'react-table'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {Loading} from '../../../../../components/table/loading/Loading'
import {Pagination} from '../../../../../components/table/pagination/Pagination'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
} from '../core/QueryResponseProvider'
import {HazardManagement} from '../core/_models'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {rejectedWorkAuthorizationColumns} from './columns/_columns'

const RejecteddWorkAuthorizationTable = () => {
  const intl = useIntl()
  const equipments = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => equipments, [equipments])
  const columns = useMemo(() => rejectedWorkAuthorizationColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_transaction'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<HazardManagement>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<HazardManagement>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {intl.formatMessage({id: 'TABLE.NO_RECORDS_FOUND'})}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        useQueryRequest={useQueryRequest}
        useQueryResponsePagination={useQueryResponsePagination}
        useQueryResponseLoading={useQueryResponseLoading}
      />
      {isLoading && <Loading />}
    </KTCardBody>
  )
}

export {RejecteddWorkAuthorizationTable}
